import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is W/m2K
export const uValue: BaseQuantity = {
  id: "001uvalue",
  name: "u-value",
  type: "numeric",
  value: "",
  symbol: "U",
  baseUnit: "W/m\u00b2\u00B7K",
  selectedUnit: "W/m\u00b2\u00B7K",
  units: [{ name: "W/m\u00b2\u00B7K", fromConst: 1, toConst: 1 }],
};
